/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef, Fragment } from 'react';
import plus from '../images/plus_color.svg';
import { useDispatch, useSelector } from 'react-redux';
import { create as createActivity, byBook } from '../Store/api/activities';
import Question from './Question';
import DynamicInput from './atoms/DynamicInput';
import image from '../assets/images/model/image-icon.svg';
import helpMark from '../assets/images/model/help-circle-1.svg';
import vidoe from '../assets/images/model/video_icon.svg';
import userImag from '../assets/images/model/user_img.png';
import audio from '../assets/images/model/audio-icon.svg';
import plusCricle from '../assets/images/model/plus-addmedia.svg';
import UploadedVideo from '../Pages/Book/addMedia/UploadedVideo';
import UploadAudio from '../Pages/Book/addMedia/UploadAudio';
import UploadingVideo from '../Pages/Book/addMedia/UploadingVideo';
import UploadVideo from '../Pages/Book/addMedia/UploadVideo';
import UploadedImage from '../Pages/Book/addMedia/UploadedImage';
import UploadingImages from '../Pages/Book/addMedia/UploadingImage';
import UploadImage from '../Pages/Book/addMedia/UploadImage';
import { setOpenActivity } from '../Store/ui/reader';
import '../../src/Pages/Book/createbook.css';
import '../../src/Pages/Book/createbookresponsive.css';
import { edit as editActivity, remove as deleteActivity } from '../Store/api/activities';
import { useNavigate } from 'react-router-dom';
import { setActivityQuestions } from '../Store/entities/activityQuestions';
import MediaComponent from './activity/MediaComponent';
import ActivityMedia from './ActivityMedia';
const types = {
  mcqs: 'multiple choice',
  fr: 'long response',
  truefalse: 'true and false',
  matching: 'matching',
  blanks: 'fill in the blanks',
  sa: 'short response',
  or: 'order list',
};

const NewActivity = ({
  activity,
  mode = 'create',
  index,
  bookId,
  chap,
  paragraphs,
  sections,
  setHighlightedParagraph,
  setGreyedPharagraphs,
  setHighlightedSection,
  setGreyedItem,
  setNewActivities,
  spreadActivitiesSetter = () => {},
  pop = (id) => {},
  setPreviewActivity,
  setViewableActivities,
}) => {
  const dispatch = useDispatch();
  const templates = useSelector((state) => state.ui.templates);
  const { user } = useSelector((state) => state.auth);
  const elRef = useRef(null);
  const navigate = useNavigate();
  const [editing, setEditing] = useState(true);
  const [openMedia, setOpenMedia] = useState(false);
  const [selectedMediaType, setSelectedMediaType] = useState(false);
  const [selectedUploadingImag, setSelectedUploadingImag] = useState(false);
  const [uploadedImag, setUploadedImag] = useState(false);
  const [uploadVideo, setUploadVideo] = useState(false);
  const [uploadingVideo, setUploadingVideo] = useState(false);
  const [uploadedVideo, setUploadedVideo] = useState(false);
  const [uploadAudioShow, setUploadAudioShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mediaList, setMediaList] = useState([]);

  const [newActivity, setNewActivity] = useState({
    ...activity,
    chapter:
      activity.element && activity.element.index
        ? activity.element.index.split('.')[0]
        : chap.split('.')[0],
    section:
      activity.element && activity.element.index
        ? activity.element.index.split('.')[1]
        : chap.split('.')[1],
  });

  /* Activity media choose */

  /* ................. */

  const setName = (e) => {
    // setNewActivity({ ...newActivity, title: e.target.value });
    setNewActivities((old) =>
      old.map((a, i) =>
        i !== index
          ? a
          : {
              ...a,
              title: e.target.value,
            }
      )
    );
  };
  const setDesc = (e) => {
    setNewActivities((old) =>
      old.map((a, i) =>
        i !== index
          ? a
          : {
              ...a,
              description: e.target.value,
            }
      )
    );
  };

  const editQuestion = (e, qIndex) => {
    const { name, value } = e.target;
    setNewActivities((oldAct) =>
      oldAct.map((a, ai) =>
        ai !== index
          ? a
          : {
              ...a,
              questions: a.questions.map((q, qi) => (qi !== qIndex ? q : { ...q, [name]: value })),
            }
      )
    );
  };

  const handleQuestionLevelMedia = (fileUrl, qIndex, mediaIndex, fileType = 'image') => {
    const newActivity = JSON.parse(JSON.stringify(activity));

    // Find and update the correct question
    newActivity.questions = newActivity.questions.map((question, index) => {
      if (index !== qIndex) return question;

      // Ensure mediaList exists
      let mediaList = question.mediaList || [];

      // Update or add media at the correct index
      if (mediaList[mediaIndex]) {
        mediaList[mediaIndex].url = fileUrl;
        mediaList[mediaIndex].type = fileType;
      } else {
        mediaList.push({ url: fileUrl, type: fileType });
      }

      return {
        ...question,
        mediaList,
        questionMediaTypeUrl: mediaList[mediaIndex]?.url || mediaList[0]?.url || '',
        questionInstructionsType: mediaList[mediaIndex]?.type || mediaList[0]?.type || 'text',
      };
    });

    // Now update your state
    setNewActivities((oldActivities) =>
      oldActivities.map((a, i) => (i === index ? newActivity : a))
    );
  };

  const removeQuestion = (qIndex) => {
    setNewActivities((oldAct) =>
      oldAct.map((a, ai) =>
        ai !== index ? a : { ...a, questions: a.questions.filter((q, qi) => qi !== qIndex) }
      )
    );
  };

  const setDifficulty = (qIndex, value) => {
    const question = { ...activity?.questions[qIndex] };
    let score = question.score;
    switch (question.type) {
      case 'mcqs':
        score = value === 1 ? 1 : value === 2 ? 2 : 4;
        break;
      case 'blanks':
        score =
          value === 1
            ? 0.5 * question?.blanksBank?.length
            : value === 2
            ? 1 * question?.blanksBank?.length
            : 2 * question?.blanksBank?.length;
        break;
      case 'fr':
        score = value === 1 ? 3 : value === 2 ? 6 : 12;
        break;
      case 'sa':
        score = value === 1 ? 1.5 : value === 2 ? 3 : 6;
        break;
      case 'truefalse':
        score = value === 1 ? 0.5 : value === 2 ? 1 : 2;
        break;
      default:
        score = value === 1 ? 0.25 : value === 2 ? 0.5 : 1;
        break;
    }
    setNewActivities((oldAct) =>
      oldAct.map((a, ai) =>
        ai !== index
          ? a
          : {
              ...a,
              questions: a.questions.map((q, qi) =>
                qi !== qIndex ? q : { ...q, difficulty: value, score: score }
              ),
            }
      )
    );
  };

  let isZero = false;
  const score = activity.questions.reduce((acc, next) => {
    if (next.score === '0') isZero = true;
    return acc + Number(next.score);
  }, 0);
  useEffect(() => {
    const handleClick = (event) => {
      if (elRef.current && !elRef.current.contains(event.target)) {
        // Clicked outside of the wrapperRef
        setOpenMedia(false);
      }
    };

    // Attach the event listener to the body when the component mounts
    document.body.addEventListener('click', handleClick);

    // Clean up the event listener when the component unmounts
    return () => {
      document.body.removeEventListener('click', handleClick);
    };
  }, []);

  const handleShare = () => {
    setNewActivities((old) =>
      old.map((a, ai) => (ai === index ? { ...a, isShared: !a.isShared } : a))
    );
  };

  const handleMediaUpload = (fileUrl, mediaIndex) => {
    setMediaList((prev) =>
      prev.map((item, i) => (i === mediaIndex ? { ...item, url: fileUrl } : item))
    );
  };

  return (
    <div
      className='right_box_border dashed-border-box'
      style={{ background: 'var(--Grey-100, #FAFAF9)' }}
      key={index}
    >
      <div className='tab-content'>
        <div
          className='tab-pane fade show active'
          id='nav-create'
          role='tabpanel'
          aria-labelledby='nav-create-tab'
        >
          <div className='auto_grade_wrap'>
            <div className='chapter_box_head'>
              <div className='content_head mb-0'>
                <h5>
                  auto-graded
                  <span style={{ cursor: 'pointer' }}>
                    <a
                      className='text-danger'
                      onClick={(e) => {
                        e.stopPropagation();
                        const sure = window.confirm('Do you really want to delete this activity?');

                        if (sure) {
                          if (!activity._id) {
                            pop(activity.id);
                          } else {
                            dispatch(
                              deleteActivity({
                                id: activity._id,
                                onSuccess: (res) => {
                                  pop(activity.id);
                                  setPreviewActivity(false);
                                  dispatch(
                                    byBook({
                                      id: bookId,
                                      onSuccess: (res) => {
                                        setGreyedItem('');
                                        setHighlightedParagraph('');
                                        setHighlightedSection('');
                                        setGreyedPharagraphs([]);
                                      },
                                    })
                                  );
                                },
                              })
                            );
                          }
                        }
                      }}
                    >
                      <u>Delete</u>
                    </a>{' '}
                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={(e) => {
                        e.preventDefault();
                        if (mode === 'assign') {
                          dispatch(setOpenActivity(activity));
                          navigate('/create/' + activity.book);
                        } else {
                          spreadActivitiesSetter(activity._id);
                          setEditing((old) => !old);
                        }
                      }}
                    >
                      {mode === 'create' ? (editing ? 'editing' : 'editing') : 'edit in create'}
                    </a>
                    <div className='user_img_chapter'>
                      {' '}
                      <img src={userImag} alt='user' />{' '}
                    </div>
                  </span>
                </h5>
              </div>
            </div>
            <div className='auto_grade_from'>
              <DynamicInput
                className={'Definitioninput'}
                placeHolder={'Name your activity'}
                onChange={setName}
                name={'title'}
                value={activity.title}
                autoFocus={true}
                readOnly={false}
              />
              <input
                type='hidden'
                className='pointsinput'
                placeholder='points auto-calculated from questions'
                readOnly
                value={
                  score === 0 ? (isZero ? 0 : 'points auto-calculated from questions') : score
                }
              />
              <input
                type='text'
                className='pointsinput fst-normal'
                placeholder='points auto-calculated from questions'
                readOnly
                // value={"Points auto-calculated from questions"}
              />

              <ActivityMedia
                handleMediaUpload={handleMediaUpload}
                setOpenMedia={setOpenMedia}
                setMediaList={setMediaList}
                openMedia={openMedia}
                mediaList={mediaList}
                activity={activity?.description}
                setDesc={setDesc}
                elRef={elRef}
              />

              {activity.questions.map((question, qIndex) => {
                return (
                  <Question
                    activityScore={score}
                    setDifficulty={setDifficulty}
                    key={qIndex}
                    question={question}
                    index={qIndex}
                    actIndex={index}
                    score={score}
                    editQuestion={editQuestion}
                    types={types}
                    setNewActivities={setNewActivities}
                    removeQuestion={removeQuestion}
                    setEditing={setEditing}
                    handleQuestionLevelMedia={handleQuestionLevelMedia}
                  />
                );
              })}
              <div className='add_plus'>
                {editing ? (
                  <Fragment>
                    <p className='mt-3'>
                      <img src={plus} alt='plus' className='mr-3' />
                      Add a{' '}
                      <div className='Multiplechoice_wrap' style={{ display: 'inline-flex' }}>
                        <div className='btn-group'>
                          <button
                            type='button'
                            className='btn btn-link dropdown-toggle'
                            data-bs-toggle='dropdown'
                            aria-expanded='false'
                            style={{ margin: '0 4px' }}
                          >
                            multiple-choice
                          </button>
                          <ul className='dropdown-menu cursor'>
                            {templates.map((temp, tempIndex) => (
                              <li key={tempIndex}>
                                <a
                                  className='dropdown-item crusor'
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setNewActivities((oldAct) =>
                                      oldAct.map((a, ai) =>
                                        ai !== index
                                          ? a
                                          : {
                                              ...a,
                                              questions: [
                                                ...a.questions,

                                                {
                                                  type: temp.type,
                                                  text: '',
                                                  description: '',
                                                  score:
                                                    temp.type === 'mcqs'
                                                      ? 1
                                                      : temp.type === 'truefalse'
                                                      ? 0.5
                                                      : temp.type === 'fr'
                                                      ? 3
                                                      : temp.type === 'sa'
                                                      ? 1.5
                                                      : temp.type === 'blanks'
                                                      ? 0.5
                                                      : 0.25,
                                                  difficulty: 1,
                                                  sentence: '',
                                                  blanksBank: [],
                                                  bankQuestion: [],
                                                  options:
                                                    temp.type === 'truefalse'
                                                      ? [
                                                          {
                                                            type: 'text',
                                                            text: 'True',
                                                            isCorrect: false,
                                                          },
                                                          {
                                                            type: 'text',
                                                            text: 'False',
                                                            isCorrect: false,
                                                          },
                                                        ]
                                                      : temp.type === 'mcqs'
                                                      ? []
                                                      : [],
                                                },
                                              ],
                                            }
                                      )
                                    );
                                  }}
                                >
                                  {temp.name}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>{' '}
                      question to this activity
                    </p>
                    <button
                      disabled={loading}
                      className='bnt_save'
                      onClick={() => {
                        let error = '';
                        const newActivity = JSON.parse(JSON.stringify(activity));

                        newActivity.chapter =
                          activity.element && activity.element.index
                            ? activity.element.index.split('.')[0]
                            : chap.split('.')[0];
                        newActivity.section =
                          activity.element && activity.element.index
                            ? activity.element.index.split('.')[1]
                            : chap.split('.')[1];
                        newActivity.activityInstructionUrl = mediaList[0]?.url;
                        newActivity.activityInstructionsType = mediaList[0]?.type || 'text';
                        newActivity.questions = newActivity.questions.map((question) => {
                          const lastMedia = question.mediaList?.length
                            ? question.mediaList[question.mediaList.length - 1]
                            : null;

                          return {
                            ...question,
                            questionMediaTypeUrl: lastMedia?.url || '',
                            questionInstructionsType: lastMedia?.type || 'text',
                          };
                        });
                        if (!newActivity.title) error = 'Title is required.';
                        if (!newActivity.questions || !Array.isArray(newActivity.questions)) {
                          error = 'There must be at least one question.';
                        } else {
                          for (let index = 0; index < newActivity.questions.length; index++) {
                            const question = newActivity.questions[index];
                            if (!question.text) {
                              error = 'Each question must have a text/title.';
                              break;
                            }
                            if (question.type === 'mcqs') {
                              if (
                                !question.options ||
                                !Array.isArray(question.options) ||
                                question.options.length <= 1
                              ) {
                                error = 'MCQs questions must have more than one option.';
                                break;
                              } else {
                                let optionError = true;
                                for (
                                  let optionIndex = 0;
                                  optionIndex < question.options.length;
                                  optionIndex++
                                ) {
                                  const option = question.options[optionIndex];
                                  if (
                                    !option.text &&
                                    !['image', 'audio', 'video'].includes(option.type)
                                  ) {
                                    error = 'Each option must have some text.';
                                    break;
                                  }
                                  if (option.isCorrect) {
                                    optionError = false;
                                  }
                                }
                                if (optionError)
                                  error =
                                    'There must be at least one correct option in each MCQs question.';
                              }
                            }
                            if (question.type === 'truefalse') {
                              let hasCorrect = question.options.some((option) => option.isCorrect);
                              if (!hasCorrect) {
                                error =
                                  'True/False question must have at least one correct answer.';
                              }
                            }
                          }
                        }
                        if (error !== '') {
                          alert(error);
                          return;
                        }
                        delete newActivity.element;
                        delete newActivity.name;
                        delete newActivity.id;
                        setLoading(true);
                        dispatch(
                          createActivity({
                            body: {
                              ...newActivity,
                              paragraphs,
                              sections,
                              score,
                              createdBy: user._id,
                              owner: user._id,
                            },
                            onSuccess: (res) => {
                              setLoading(false);
                              dispatch(
                                byBook({
                                  id: bookId,
                                  onSuccess: (res) => {},
                                })
                              );
                              pop(activity.id);
                              setViewableActivities((old) => [...old, res.data.data]);
                              dispatch(setActivityQuestions(res.data.data));
                              setPreviewActivity(true);
                            },
                            onError: (err) => {
                              setLoading(false);
                              alert(err.response.data.message);
                            },
                          })
                        );
                      }}
                    >
                      {loading ? 'Creating ...' : 'Save and link to highlighted section'}
                    </button>
                    <div className='share iagree_radio blanks-opt '>
                      <input
                        type='checkbox'
                        id='share-activity'
                        checked={activity.isShared}
                        onChange={handleShare}
                        className=''
                      />
                      <label htmlFor='share-activity'>
                        Share activity on Greyled{'  '} {'  '}
                        <img style={{ paddingLeft: '4px' }} src={helpMark} alt='help logo' />
                      </label>
                    </div>
                  </Fragment>
                ) : (
                  <div className='share iagree_radio blanks-opt d-flex align-items-center'>
                    <input
                      type='checkbox'
                      id='share-activity'
                      checked={activity.isShared}
                      onChange={handleShare}
                    />
                    <label htmlFor='share-activity'>Share activity on Greyled</label>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className='tab-pane fade'
          id='nav-connected'
          role='tabpanel'
          aria-labelledby='nav-connected-tab'
        >
          connected activities
        </div>
      </div>
      {selectedMediaType && (
        <UploadImage
          setSelectedMediaType={setSelectedMediaType}
          setSelectedUploadingImag={setSelectedUploadingImag}
        />
      )}
      {selectedUploadingImag && (
        <UploadingImages
          setSelectedMediaType={setSelectedMediaType}
          setSelectedUploadingImag={setSelectedUploadingImag}
          setUploadedImag={setUploadedImag}
        />
      )}
      {uploadedImag && (
        <UploadedImage
          setUploadedImag={setUploadedImag}
          setSelectedUploadingImag={setSelectedUploadingImag}
        />
      )}
      {/* Upload Video */}
      {uploadVideo && (
        <UploadVideo setUploadVideo={setUploadVideo} setUploadingVideo={setUploadingVideo} />
      )}
      {uploadingVideo && (
        <UploadingVideo
          setUploadVideo={setUploadVideo}
          setUploadingVideo={setUploadingVideo}
          setUploadedVideo={setUploadedVideo}
        />
      )}
      {uploadedVideo && (
        <UploadedVideo setUploadedVideo={setUploadedVideo} setUploadingVideo={setUploadingVideo} />
      )}
      {/* For Audio */}
      {uploadAudioShow && (
        <UploadAudio uploadAudio={uploadAudioShow} setUploadAudioShow={setUploadAudioShow} />
      )}
    </div>
  );
};
export default NewActivity;
